export enum Degrees {
  HIGHSCHOOL = 'High School',
  UNDERGRADUATE = 'Undergraduate',
  GRADUATE = 'Graduate',
  OTHER = 'Other',
}
export default Degrees;
